// @flow
import type {Action} from '../../../state/types'

export type SetReadyPayload = {
}

const id = 'map/SET_READY'

export const setReady = (): Action<SetReadyPayload> => ({
  type: id,
  payload: {
  }
})

setReady.id = id
